import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";

@Injectable({
    providedIn: "root",
})
export class TemplateDownloadService {
    async downloadTemplate(
        templateName = "Venduro cart upload sample.csv"
    ): Promise<void> {
        const timestamp = new Date().getTime();
        const externalUrl = environment.apiPort
            ? `${environment.apiHost}:${environment.apiPort}/csv/productsTemplate?cacheBust=${timestamp}`
            : `${environment.apiHost}/csv/productsTemplate?cacheBust=${timestamp}`;

        const token = localStorage.getItem("auth_token");

        try {
            const response = await fetch(externalUrl, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                throw new Error("You need to be signed in");
            }

            const blob = await response.blob();
            const contentDisposition = response.headers.get("content-disposition");
            let finalFilename = templateName;
            
            if (contentDisposition) {
                const filenameMatch = contentDisposition.match(/filename="?([^";]+)"?/);
                if (filenameMatch && filenameMatch[1]) {
                    finalFilename = filenameMatch[1];
                }
            }

            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = finalFilename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error("Error downloading template:", error);
            throw error;
        }
    }
}
